import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ZalamoObject } from '../../../../../graphql';

@Component({
    selector: 'app-private-session-created',
    templateUrl: './private-session-created.component.html',
    styleUrls: ['./private-session-created.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivateSessionCreatedComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.PrivateSessionCreated];
  ob: ZalamoObject = ZalamoObject.OrganizationClient;

  constructor() {}

  ngOnInit(): void {}
}
